module.exports = __webpack_public_path__ + "img/yeshi.4d37200c.jpg";